export const newFolderAction = "agCw7";
export const newFolderAnnouncementText = "y$R3Od";
export const renameFolderAnnouncementText = "OK2FFb";
export default {newFolderAction,newFolderAnnouncementText,renameFolderAnnouncementText};